import React from 'react';
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import PlanScreen from "../screens/PlansScreen";
import BillingScreen from "../screens/BillingScreen";
import AuthScreen from "../screens/AuthScreen";
import ThanksScreen from "../screens/ThanksScreen";
import { AnvilProps } from "frontend/hooks";
import AlreadySubscribedScreen from "../screens/AlreadySubscribedScreen";
import {ScrollToTop} from "frontend/react-router-helpers/components";


/**
 * HOC for the Subscription Order Tunnel
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function OrderTunnel(props) {
    const {
        initial_location: initialLocation,
    } = props;

    // Remove facebook's hash upon successful social login
    if (window.location.hash === "#_=_")
        window.location.hash = "";

    return (
        // HashRouter allows ReactRouter to handle routing on a single Django URL
        <HashRouter>
            <ScrollToTop />
            <AnvilProps.Provider value={props}>
                <Switch>
                    {initialLocation && (
                        <Redirect exact path="/" to={initialLocation}/>
                    )}
                    <Redirect exact from="/" to={'/plans'}/>
                    <Route path={'/plans'}>
                        <PlanScreen/>
                    </Route>
                    <Route path={'/billing/:product_pk'}>
                        <BillingScreen/>
                    </Route>
                    <Route path={'/auth'}>
                        <AuthScreen/>
                    </Route>
                    <Route path={'/thanks'}>
                        <ThanksScreen/>
                    </Route>
                    <Route path={'/already-subbed'}>
                        <AlreadySubscribedScreen/>
                    </Route>
                </Switch>
            </AnvilProps.Provider>
        </HashRouter>
    );
}
